<template>
  <v-app class="page page-base dashboard">
    <v-app-bar
      class="header-list pl-6 pr-8 py-3"
      app
      fixed
      elevation="0"
      color="lightPrimary"
      height="80"
    >
    <div class="d-flex flex-grow-1 justify-space-between">
       <div class="d-flex align-center">
         <div class="d-flex gp-8">
           <v-btn text class="custom-btn-icon-gray pa-3 icon-tam-20" v-on:click="
              $router.push('/admin/map')
              ">
             <v-icon>$arrowRightIcon</v-icon>
           </v-btn>
         </div>
          <v-breadcrumbs
              class="menu-breadcrumbs pa-0 ml-4"
              :items="breadcrumbs"
              divider=">"
                  >
            </v-breadcrumbs>
       </div>
       <div class="d-flex align-center">
        <NotificationMenu></NotificationMenu>
       </div>
    </div>
      


      <!-- <v-tooltip>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            :elevation="0"
            class="ml-5 mr-5"
            v-bind="attrs"
            v-on="on"
            v-on:click="exportCSV"
          >
            <v-icon left>fas fa-file</v-icon>
            XLS
          </v-btn>
        </template>
        <span>{{ labelExport }}</span>
      </v-tooltip> -->
    </v-app-bar>
    <v-main class="dashboard">
      <v-container fluid class="fill-height pr-0 pa-0">
        <v-card
          width="100%"
          elevation="0"
          class="full-height fill-width fill-height card-content"
          :loading="status == 'loading'"
        >
          <v-card-text style="display: flex; gap: 40px; flex-wrap: wrap;">
            <div class="d-flex justify-space-between" style="flex: auto;">
              <div><h3 class="fonts-s24 fonts-600 fonts-color-dark"> Métricas</h3></div>
              <div class="d-flex align-center ">
                <DateTimeRangePicker v-model="range_date" class="mr-3"></DateTimeRangePicker>
                
                <!--  <v-menu
                  ref="menu_to"            
                  v-model="menu_to"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y 
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      label="Hasta"
                      prepend-icon="fas fa-calendar"                
                      readonly
                      hide-details
                      :value="toDateDisp"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    locale="en-in"
                    v-model="date_to"
                    no-title
                    @input="menu_to = false"              
                  ></v-date-picker>
                </v-menu>
                <v-menu            
                  v-model="menu_from"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y 
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      label="Desde"
                      prepend-icon="fas fa-calendar"                
                      readonly
                      hide-details
                      :value="fromDateDisp"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    locale="en-in"
                    v-model="date_from"
                    no-title
                    @input="menu_from = false"              
                  ></v-date-picker>
                </v-menu> -->
                <div class="position-relative">
                  <v-tooltip bottom :attach="false">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        rounded
                        :elevation="0"
                        class="btn-round-md custom-btn-round-gray fonts-s14 fonts-600"
                        v-bind="attrs"
                        v-on="on"
                        v-on:click="exportCSV"
                      >
                        <v-icon left>$downloadIcon</v-icon>
                        XLS
                      </v-btn>
                    </template>
                    <span>{{ labelExport }}</span>
                  </v-tooltip>
                </div>
              </div>
            </div>
            <div class="d-flex content-metrics align-items-stretch justify-space-between" style="flex-wrap: wrap; width: 100%;">
              <v-card class="mx-0 card-metrics pa-4" >
                <v-card-text class="d-flex flex-column align-items-start pa-0 white--text">
                  <div><v-icon class="mb-0" color="white">$financesIcon</v-icon></div>
                  <div class="fonts-s18 fonts-500 custom-m-b6 mt-4">Ingreso de dinero total:</div>
                  <div class="fonts-s20 fonts-500">{{ formatUSD(Number(totals.total_monetary_income)) }}</div>
                </v-card-text>
              </v-card>

              <v-card class="mx-0 card-metrics pa-4">
                <v-card-text class="d-flex flex-column align-items-start pa-0 white--text">
                  <div><v-icon class="mb-0" color="white">$clockCounterIcon</v-icon></div>
                  <div class="fonts-s18 fonts-500 custom-m-b6 mt-4">Estadías totales:</div>
                  <div class="fonts-s20 fonts-500">{{ formatMiles(Number(totals.total_stays)) }}</div>
                </v-card-text>
              </v-card>

              <v-card class="mx-0 card-metrics pa-4">
                <v-card-text class="d-flex flex-column align-items-start pa-0 white--text">
                  <div><v-icon class="mb-0" color="white">$spotsIcon</v-icon></div>
                  <div class="fonts-s18 fonts-500 custom-m-b6 mt-4">Conductores totales:</div>
                  <div class="fonts-s20 fonts-500">{{ formatMiles(Number(totals.total_drivers)) }}</div>
                </v-card-text>
              </v-card>

              <v-card class="mx-0 card-metrics pa-4">
                <v-card-text class="d-flex flex-column align-items-start pa-0 white--text">
                  <div><v-icon class="mb-0" color="white">$coinsIcon</v-icon></div>
                  <div class="fonts-s18 fonts-500 custom-m-b6 mt-4">Coins compradas:</div>
                  <div class="fonts-s20 fonts-500 ">{{ formatMiles(Number(totals.total_purchased_coins)) }}</div>
                </v-card-text>
              </v-card>
            </div>
            
            <v-row class="content-results">
              <v-col cols="12" md="6" class="px-2" >
                <div class="d-flex flex-column gp-16">
                <v-card class="card-results">
                  <v-card-title class="fonts-s18 fonts-600">Estadías</v-card-title>
                  <v-card-text>
                    <div class="d-flex gp-4 mb-4" >
                      <div class="flex-item-1">
                        <div class="chip-item fonts-s14 fonts-500">Totales: <span>{{ formatMiles(Number(data_estadias.total_estadias))}}</span>  </div>    
                      </div>
                      <div class="flex-item-1">
                        <div class="chip-item fonts-s14 fonts-500">Tiempo promedio: <span>{{ formatMiles(Number(data_estadias.time_quantity_promedio))}}</span></div>
                      </div>
                    </div>
                    <div class="d-flex gp-4" >
                      <div class="flex-item-1">
                        <div class="chip-item fonts-s14 fonts-500">Tiempo máximo: <span>{{ formatMiles(Number(data_estadias.max_time_quantity))}}</span></div>
                      </div>
                      <div class="flex-item-1">
                        <div class="chip-item fonts-s14 fonts-500">Tiempo mínimo: <span>{{ formatMiles(Number(data_estadias.min_time_quantity))}}</span></div>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
                <v-card class="card-results">
                  <v-card-title class="fonts-s18 fonts-600">Coins</v-card-title>
                  <v-card-text>
                    <div class="d-flex gp-4 mb-4">
                      <div class="flex-item-1">
                        <div class="chip-item fonts-s14 fonts-500">
                          Totales: <span>{{ formatMiles(Number(data_coins.total_coins)) }}</span>
                        </div>
                      </div>
                      <div class="flex-item-1">
                        <div class="chip-item fonts-s14 fonts-500">
                          Compradas: <span>{{ formatMiles(Number(data_coins.purchased_coins)) }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex gp-4">
                      <div class="flex-item-1">
                        <div class="chip-item fonts-s14 fonts-500">
                          Liquidadas: <span>{{ formatMiles(Number(data_coins.total_to_liquidate)) }}</span>
                        </div>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
                </div>
              </v-col>
              <v-col cols="12" md="6" class="px-2">
                <div class="d-flex flex-column gp-16">
                  <v-card class="card-results">
                    <v-card-title class="fonts-s18 fonts-600">Conductores</v-card-title>
                    <v-card-text>
                      <div class="d-flex gp-4 mb-4">
                        <div class="flex-item-1">
                          <div class="chip-item fonts-s14 fonts-500">
                            Totales: <span>{{ formatMiles(Number(data_drivers.total_user_with_car_or_coin)) }}</span>
                          </div>
                        </div>
                        <div class="flex-item-1">
                          <div class="chip-item fonts-s14 fonts-500">
                            Con coche: <span>{{ formatMiles(Number(data_drivers.total_user_with_car_and_without_coin)) }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex gp-4 mb-4">
                        <div class="flex-item-1">
                          <div class="chip-item fonts-s14 fonts-500">
                            Con coins: <span>{{ formatMiles(Number(data_drivers.total_user_with_coin)) }}</span>
                          </div>
                        </div>
                        <div class="flex-item-1">
                          <div class="chip-item fonts-s14 fonts-500">
                            Con coche + coins: <span>{{ formatMiles(Number(data_drivers.total_user_with_car_and_coin)) }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex gp-4">
                        <div class="flex-item-1">
                          <div class="chip-item fonts-s14 fonts-500">
                            Cantidad de conductores únicos con estadías hechas: 
                            <span>{{ formatMiles(Number(data_drivers.total_user_with_estadias)) }}</span>
                          </div>
                        </div>
                      </div>
                    </v-card-text>

                  </v-card>
                  <v-card class="card-results">
                    <v-card-title class="fonts-s18 fonts-600">Hosts</v-card-title>
                    <v-card-text>
                        <div class="d-flex gp-4 ">
                          <div class="flex-item-1">
                            <div class="chip-item fonts-s14 fonts-500">
                              Totales: <span>{{ formatMiles(Number(data_hosts.total_hosts)) }}</span>
                            </div>
                          </div>
                          <div class="flex-item-1">
                            <div class="chip-item fonts-s14 fonts-500">
                              Con estadías: <span>{{ formatMiles(Number(data_hosts.spot_with_estadias)) }}</span>
                            </div>
                          </div>
                        </div>
                      </v-card-text>
                  </v-card>
                </div>
              </v-col>
              
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
    </v-main>

  </v-app>
</template>

<style>
  .text-h4{
    color: #000000;
  }
  .v-application{
    font-family: 'Poppins', sans-serif !important;
  }
</style>

<script>
import { mapState } from "vuex";
import {format} from "currency-formatter";
import DateTimeRangePicker from "@/components/Form/DateRangePicker";
import NotificationMenu from "@/components/Notification/NotificationMenu.vue";
export default {
  data() {
    return {
      range_date: null,
      breadcrumbs: [
        {
          text: "General",
          disabled: false,
          href: "#",
        },
        {
          text: "Dashboard",
          disabled: false,
          href: "#",
        },
      ],
      storeName: "Dashboard",
      title: "DASHBOARD",
      labelExport: "Exportar",
      search: "",
      filters: {
        date_from: null,
        date_to: null
      },
      menu_from: false,
      menu_to: false, 
      date_from: null,          
      date_to: null,
      totals: {
        total_monetary_income: 0,
        total_stays: 0,
        total_drivers: 0,
        total_purchased_coins: 0,
      },
      data_estadias: {
        total_estadias: 0,
        time_quantity_promedio: 0,
        max_time_quantity: 0,
        min_time_quantity: 0,
      },
      data_drivers: {
        total_user_with_car_or_coin: 0,
        total_user_with_car: 0,
        total_user_with_coin: 0,
        total_car_and_coin: 0,
        total_user_with_estadias: 0,
      },
      data_hosts:{
        total_hosts: 0,
        spot_with_estadias: 0,
      },
      data_coins:{
        total_coins: 0,
        purchased_coins: 0,
        total_to_liquidate: 0,
      }
    };
  },
  components: {
    DateTimeRangePicker,
    NotificationMenu
  },
  computed: {
    ...mapState({
    }),
    fromDateDisp() {
      return this.date_from;
    },
    toDateDisp() {
      return this.date_to;
    },
    status() {
      return this.$store.state[this.storeName].status;
    },
  },
  async created() {
   this.changeData();
  },
  watch: {
    range_date(data) {
      if (!data) return;
      const format = (d) => {
        if (!d) return null;
        const date = new Date(d);
        return date.toISOString().slice(0, 10);
      };
      this.date_from = format(data.start);
      this.date_to = format(data.end);
    },
    async date_from(data) {
      this.changeData();
    },
    async date_to(data) {
      this.changeData();
    },
  },
  methods: {
    async searchRows() {

    },
    async exportCSV(){
      let filters = {};
      if(this.date_from) filters.date_from = this.date_from;
      if(this.date_to) filters.date_to = this.date_to;

      await this.$store.dispatch("Dashboard/getApiExport",filters);
    },
    async changeData(){
      
      let filters={}
      if(this.date_from) filters.date_from = this.date_from;
      if(this.date_to) filters.date_to = this.date_to;

      await this.$store.dispatch("Dashboard/show_dashboard",filters).then( resp => {
      this.totals.total_monetary_income = resp.total_monetary_income;
      this.totals.total_stays = resp.total_stays;
      this.totals.total_drivers = resp.total_drivers;
      this.totals.total_purchased_coins = resp.total_purchased_coins;

      // data estadias
      this.data_estadias.total_estadias = resp.total_estadias;
      this.data_estadias.time_quantity_promedio = resp.time_quantity_promedio;
      this.data_estadias.max_time_quantity = resp.max_time_quantity;
      this.data_estadias.min_time_quantity = resp.min_time_quantity;
      // data drivers
      this.data_drivers.total_user_with_car_or_coin = resp.total_user_with_car_or_coin;
      this.data_drivers.total_user_with_car_and_without_coin = resp.total_user_with_car_and_without_coin;
      this.data_drivers.total_user_with_coin = resp.total_user_with_coin;
      this.data_drivers.total_user_with_car_and_coin = resp.total_user_with_car_and_coin;
      this.data_drivers.total_user_with_estadias = resp.total_user_with_estadias;
      // data hosts
      this.data_hosts.total_hosts = resp.total_hosts;
      this.data_hosts.spot_with_estadias = resp.spot_with_estadias;
      // data coins 
      this.data_coins.total_coins = resp.total_coins;
      this.data_coins.purchased_coins = resp.purchased_coins;
      this.data_coins.total_to_liquidate = resp.total_to_liquidate;
    });
    },
    formatUSD(value) {
      return format(Number(value).toFixed(2), {
        code: "USD",
        decimal: ",",
        thousand: ".",
        format: "%s %v",
      });
    },
    formatMiles(value) {
      return format(Number(value), {
        precision: 0,   // 👈 sin decimales
        thousand: ".",  // separador de miles
        decimal: ",",   // separador decimal (no se usa con 0 decimales)
      });
    },
  },
};
</script>